
import { Fragment, useEffect, useRef, useState } from 'react'
import { getMenuItems, MENUITEMS, type Menuitemtype } from './nav'
import Menuloop from './menuloop';
import SimpleBar from 'simplebar-react';
import { Link, useLocation } from 'react-router-dom';
import { useShellBranding } from '../../../components/cares/shell/branding';
import {
  data$,
  MOBILE_SIDEBAR_PIN_CHANGED_EVENT,
  getMobileSidebarPinned,
  getState,
  setMobileSidebarPinned,
  setState,
} from '../../services/switcherServices';

const Sidebar = () => {
  const branding = useShellBranding();
  const [mobileSidebarPinned, setMobileSidebarPinnedState] = useState(getMobileSidebarPinned());

  useEffect(() => {
    const syncPinnedPreference = () => {
      setMobileSidebarPinnedState(getMobileSidebarPinned());
    };

    window.addEventListener(MOBILE_SIDEBAR_PIN_CHANGED_EVENT, syncPinnedPreference);

    return () => {
      window.removeEventListener(MOBILE_SIDEBAR_PIN_CHANGED_EVENT, syncPinnedPreference);
    };
  }, []);

  let [variable, setVariable] = useState(getState());
  const local_varaiable = variable;

  useEffect(() => {
    const subscription = data$.subscribe((e) => {
      setVariable(e);
    });
    return () => subscription.unsubscribe();
  }, []);


  const [menuitems, setMenuitems] = useState(MENUITEMS);

  useEffect(() => {
    const handleBootstrapUpdated = () => {
      setMenuitems(getMenuItems());
    };

    window.addEventListener('cares:bootstrap-updated', handleBootstrapUpdated);

    return () => {
      window.removeEventListener('cares:bootstrap-updated', handleBootstrapUpdated);
    };
  }, []);

  function closeMenuFn() {
    const closeMenudata = (items: Menuitemtype[]) => {
      items?.forEach((item: Menuitemtype) => {
        item.active = false;
        if (item.children) {
          closeMenudata(item.children);
        }
      });
    }
    closeMenudata(MENUITEMS);
    setMenuitems((arr) => [...arr]);
  }


  const [_isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 30) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  const slidesArrow = (selector: string): HTMLElement | null => document.querySelector(selector);

  const SelectorAll = (selector: string) => document.querySelectorAll(selector);

  useEffect(() => {
    const resizeEventListeners = [
      { event: 'resize', handler: menuResizeFn },
      { event: 'resize', handler: checkHoriMenu }
    ];
    resizeEventListeners.forEach(({ event, handler }) => {
      window.addEventListener(event, handler);
    });
    const mainContent = slidesArrow(".main-content");
    if (window.innerWidth <= 992) {
      if (mainContent) {
        const newState = {
          toggled: getMobileSidebarPinned() ? "open" : "close"
        }
        setState(newState)
      } else if (document.documentElement.getAttribute('data-nav-layout') == 'horizontal') {
        closeMenuFn();
      }
    }
    if (mainContent) {
      mainContent.addEventListener('click', menuClose);
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      resizeEventListeners.forEach(({ event, handler }) => {
        window.removeEventListener(event, handler);
      });
      if (mainContent) {
        mainContent.removeEventListener('click', menuClose);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const Baselocation = useLocation()

  function Onhover() {
    const theme = getState();
    if ((theme.toggled == 'icon-overlay-close' || theme.toggled == 'detached-close') && theme.iconOverlay != 'open') {
      const newState = {
        "iconOverlay": "open"
      }
      setState(newState)
      console.log(newState)
    }

  }
  function Outhover() {
    const theme = getState();
    if ((theme.toggled == "icon-overlay-close" || theme.toggled == "detached-close") && theme.iconOverlay == "open") {
      const newState = {
        "iconOverlay": ""
      }
      setState(newState)
    }
  }

  const overlayRef = useRef<HTMLDivElement | null>(null);

  function menuClose() {

    const theme = getState();;

    if (window.innerWidth <= 992) {
      if (getMobileSidebarPinned()) {
        return;
      }

      const newState = {
        toggled: "close"
      }
      setState(newState)
    }
    if (overlayRef.current) {
      overlayRef.current.classList.remove("active");
    }
    if (theme.dataNavLayout === "horizontal" || theme.dataNavStyle === "menu-click" || theme.dataNavStyle === "icon-click") {
      closeMenuFn();
    }
  }


  const WindowPreSize = typeof window !== 'undefined' ? [window.innerWidth] : [];
  function menuResizeFn() {

    if (typeof window === 'undefined') {
      // Handle the case where window is not available (server-side rendering)
      return;
    }

    WindowPreSize.push(window.innerWidth);
    if (WindowPreSize.length > 2) { WindowPreSize.shift() }

    const theme = getState();;
    const currentWidth = WindowPreSize[WindowPreSize.length - 1];
    const prevWidth = WindowPreSize[WindowPreSize.length - 2];


    if (WindowPreSize.length > 1) {
      if (currentWidth < 992 && prevWidth >= 992) {
        // less than 992;
        const newState = {
          toggled: getMobileSidebarPinned() ? "open" : "close"
        }
        setState(newState)
      }

      if (currentWidth >= 992 && prevWidth < 992) {
        // greater than 992
        const newState = {
          toggled: theme.dataVerticalStyle === "doublemenu" ? "double-menu-open" : ""
        }
        setState(newState)



      }
    }
  }

  function toggleMobileSidebarPin() {
    const nextPinned = !mobileSidebarPinned;

    setMobileSidebarPinned(nextPinned);
    setMobileSidebarPinnedState(nextPinned);
    setState({ toggled: nextPinned ? "open" : "close" });

    document.querySelectorAll("#responsive-overlay.active").forEach((overlay) => {
      overlay.classList.remove("active");
    });
  }
  const menuNavRef = useRef<HTMLUListElement | null>(null);
  const mainContainerRef = useRef<HTMLUListElement | null>(null);

  function checkHoriMenu() {
    const menuNav = menuNavRef.current;
    const mainContainer1 = mainContainerRef.current;

    if (menuNav && mainContainer1) {
      const computedStyle = window.getComputedStyle(menuNav);
      const marginLeftValue = Math.ceil(
        Number(computedStyle.marginLeft.split("px")[0])
      );
      const marginRightValue = Math.ceil(
        Number(computedStyle.marginRight.split("px")[0])
      );
      const check = menuNav.scrollWidth - mainContainer1.offsetWidth;

      if (menuNav.scrollWidth > mainContainer1.offsetWidth) {
      } else {
        menuNav.style.marginLeft = "0px";
        menuNav.style.marginRight = "0px";
        menuNav.style.marginInlineStart = "0px";
      }

      const isRtl = document.documentElement.getAttribute("dir") === "rtl";

      if (!isRtl) {
        if (menuNav.scrollWidth > mainContainer1.offsetWidth) {
          if (Math.abs(check) < Math.abs(marginLeftValue)) {
            menuNav.style.marginLeft = -check + "px";
          }
        }
      } else {
        if (menuNav.scrollWidth > mainContainer1.offsetWidth) {
          if (Math.abs(check) < Math.abs(marginRightValue)) {
            menuNav.style.marginRight = -check + "px";
          }
        }
      }
    }
  }

  function switcherArrowFn(): void {

    // Used to remove is-expanded class and remove class on clicking arrow buttons
    function slideClick(): void {
      const slide = SelectorAll(".slide");
      const slideMenu = SelectorAll(".slide-menu");

      slide.forEach((element) => {
        if (element.classList.contains("is-expanded")) {
          element.classList.remove("is-expanded");
        }
      });

      slideMenu.forEach((element) => {
        if (element.classList.contains("open")) {
          element.classList.remove("open");
          element.style.display = "none";
        }
      });
    }

    slideClick();
  }

  function slideRight(): void {
    const menuNav = slidesArrow(".main-menu");
    const mainContainer1 = slidesArrow(".main-sidebar");
    const slideRightButton = slidesArrow("#slide-right");
    const slideLeftButton = slidesArrow("#slide-left");
    const element = slidesArrow(".main-menu > .slide.open");
    const element1 = slidesArrow(".main-menu > .slide.open > ul");
    if (menuNav && mainContainer1) {
      const marginLeftValue = Math.ceil(
        Number(window.getComputedStyle(menuNav).marginInlineStart.split("px")[0])
      );
      const marginRightValue = Math.ceil(
        Number(window.getComputedStyle(menuNav).marginInlineEnd.split("px")[0])
      );
      const check = menuNav.scrollWidth - mainContainer1.offsetWidth;
      let mainContainer1Width = mainContainer1.offsetWidth;

      if (menuNav.scrollWidth > mainContainer1.offsetWidth) {
        if (!(local_varaiable.dataVerticalStyle.dir === "rtl")) {
          if (Math.abs(check) > Math.abs(marginLeftValue)) {
            menuNav.style.marginInlineEnd = "0";

            if (!(Math.abs(check) > Math.abs(marginLeftValue) + mainContainer1Width)) {
              mainContainer1Width = Math.abs(check) - Math.abs(marginLeftValue);

              if (slideRightButton) {
                slideRightButton.classList.add("hidden");
              }
            }

            menuNav.style.marginInlineStart =
              (Number(menuNav.style.marginInlineStart.split("px")[0]) -
                Math.abs(mainContainer1Width)) +
              "px";

            if (slideRightButton) {
              slideRightButton.classList.remove("hidden");
            }
          }
        } else {
          if (Math.abs(check) > Math.abs(marginRightValue)) {
            menuNav.style.marginInlineEnd = "0";

            if (!(Math.abs(check) > Math.abs(marginRightValue) + mainContainer1Width)) {
              mainContainer1Width = Math.abs(check) - Math.abs(marginRightValue);
              if (slideRightButton) {
                slideRightButton.classList.add("hidden");
              }
            }

            menuNav.style.marginInlineStart =
              (Number(menuNav.style.marginInlineStart.split("px")[0]) -
                Math.abs(mainContainer1Width)) +
              "px";
            if (slideLeftButton) {
              slideLeftButton.classList.remove("hidden");
            }
          }
        }
      }


      if (element) {
        element.classList.remove("active");
      }
      if (element1) {
        element1.style.display = "none";
      }
    }

    switcherArrowFn();
  }

  function slideLeft(): void {
    const menuNav = slidesArrow(".main-menu");
    const mainContainer1 = slidesArrow(".main-sidebar");
    const slideRightButton = slidesArrow("#slide-right");
    const slideLeftButton = slidesArrow("#slide-left");
    const element = slidesArrow(".main-menu > .slide.open");
    const element1 = slidesArrow(".main-menu > .slide.open > ul");
    if (menuNav && mainContainer1) {
      const marginLeftValue = Math.ceil(
        Number(window.getComputedStyle(menuNav).marginInlineStart.split("px")[0])
      );
      const marginRightValue = Math.ceil(
        Number(window.getComputedStyle(menuNav).marginInlineEnd.split("px")[0])
      );
      const check = menuNav.scrollWidth - mainContainer1.offsetWidth;
      let mainContainer1Width = mainContainer1.offsetWidth;

      if (menuNav.scrollWidth > mainContainer1.offsetWidth) {
        if (!(local_varaiable.dataVerticalStyle.dir === "rtl")) {
          if (Math.abs(check) <= Math.abs(marginLeftValue)) {
            menuNav.style.marginInlineStart = "0px";
          }
        } else {
          if (Math.abs(check) > Math.abs(marginRightValue)) {
            menuNav.style.marginInlineStart = "0";

            if (!(Math.abs(check) > Math.abs(marginRightValue) + mainContainer1Width)) {
              mainContainer1Width = Math.abs(check) - Math.abs(marginRightValue);

              if (slideRightButton) {
                slideRightButton.classList.add("hidden");
              }
            }

            menuNav.style.marginInlineStart =
              (Number(menuNav.style.marginInlineStart.split("px")[0]) -
                Math.abs(mainContainer1Width)) +
              "px";

            if (slideLeftButton) {
              slideLeftButton.classList.remove("hidden");
            }
          }
        }
      }

      if (element) {
        element.classList.remove("active");
      }
      if (element1) {
        element1.style.display = "none";
      }
    }

    switcherArrowFn();
  }

  const level = 0;
  let hasParent = false;
  let hasParentLevel = 0;

  function setSubmenu(event: MouseEvent, targetObject: Menuitemtype, MENUITEMS = menuitems) {

    if (!event?.ctrlKey) {
      for (const item of MENUITEMS) {
        if (item === targetObject) {
          item.active = true;
          item.selected = true;
          setMenuAncestorsActive(item);
        } else if (!item.active && !item.selected) {
          item.active = false; // Set active to false for items not matching the target
          item.selected = false; // Set active to false for items not matching the target
        } else {
          removeActiveOtherMenus(item);
        }
        if (item.children && item.children.length > 0) {
          setSubmenu(event, targetObject, item.children);
        }
      }

    }

    setMenuitems((arr) => [...arr]);
  }
  function findMenuAncestors(
    items: Menuitemtype[],
    targetObject: Menuitemtype,
    ancestors: Menuitemtype[] = []
  ): Menuitemtype[] | null {
    for (const item of items) {
      if (item === targetObject) {
        return ancestors;
      }

      if (item.children && item.children.length > 0) {
        const childAncestors = findMenuAncestors(item.children, targetObject, [...ancestors, item]);

        if (childAncestors) {
          return childAncestors;
        }
      }
    }

    return null;
  }
  function setMenuAncestorsActive(targetObject: Menuitemtype) {
    const ancestors = findMenuAncestors(menuitems, targetObject) ?? [];
    const theme = getState();

    if (ancestors.length > 0) {
      hasParent = ancestors.length > 2;

      ancestors.forEach((ancestor) => {
        ancestor.active = true;
        ancestor.selected = true;
      });
      hasParentLevel = ancestors.length + 1;
    } else if (!hasParent) {
      if (theme.dataVerticalStyle == "doublemenu") {
        const newState = {
          toggled: "double-menu-close"
        }
        setState(newState)

      }
    }
  }
  function removeActiveOtherMenus(item: Menuitemtype | Menuitemtype[]) {
    if (!item) return;
    if (Array.isArray(item)) {
      for (const val of item) {
        val.active = false;
        val.selected = false;

        if (val.children && val.children.length > 0) {
          removeActiveOtherMenus(val.children);
        }
      }
    } else {
      item.active = false;
      item.selected = false;

      if (item.children && item.children.length > 0) {
        removeActiveOtherMenus(item.children);
      }
    }
  }
  //
  function setMenuUsingUrl(currentPath: string) {

    hasParent = false;
    hasParentLevel = 1;
    const matchedItem = findBestMenuMatch(MENUITEMS, currentPath);

    if (matchedItem) {
      setSubmenu(null, matchedItem);
    }
  }
  const [previousUrl, setPreviousUrl] = useState("/");

  function normalizeMenuPath(path: string) {
    if (path === '') {
      return '';
    }

    const normalized = new URL(path, window.location.origin);
    const pathname = normalized.pathname.endsWith("/") ? normalized.pathname.slice(0, -1) : normalized.pathname;

    return `${pathname}${normalized.search}`;
  }

  function normalizePathMatchParts(path: string) {
    const normalized = new URL(path, window.location.origin);
    const pathname = normalized.pathname.endsWith("/") ? normalized.pathname.slice(0, -1) : normalized.pathname;

    return {
      pathname,
      search: normalized.search,
    };
  }

  function isMenuPathMatch(menuPath: string, currentPath: string) {
    if (menuPath === '') {
      return false;
    }

    const normalizedMenu = normalizePathMatchParts(menuPath);
    const normalizedCurrent = normalizePathMatchParts(currentPath);

    if (normalizedMenu.search && normalizedMenu.search !== normalizedCurrent.search) {
      return false;
    }

    return normalizedCurrent.pathname === normalizedMenu.pathname
      || normalizedCurrent.pathname.startsWith(`${normalizedMenu.pathname}/`);
  }

  function findBestMenuMatch(items: Menuitemtype[], currentPath: string): Menuitemtype | null {
    let bestMatch: Menuitemtype | null = null;
    let bestMatchLength = -1;

    const search = (entries: Menuitemtype[]) => {
      entries.forEach((item) => {
        if (item.path) {
          const normalizedPath = normalizeMenuPath(item.path);

          if (isMenuPathMatch(normalizedPath, currentPath) && normalizedPath.length > bestMatchLength) {
            bestMatch = item;
            bestMatchLength = normalizedPath.length;
          }
        }

        if (item.children) {
          search(item.children);
        }
      });
    };

    search(items);

    return bestMatch;
  }

  useEffect(() => {
    const normalizedPathname = Baselocation.pathname.endsWith("/") ? Baselocation.pathname.slice(0, -1) : Baselocation.pathname;
    const currentPath = `${normalizedPathname}${Baselocation.search}`;

    if (currentPath !== previousUrl) {
      setMenuUsingUrl(currentPath);
      setPreviousUrl(currentPath);
    }
  }, [Baselocation.pathname, Baselocation.search]);


  //
  function toggleSidemenu(event: MouseEvent, targetObject: Menuitemtype, MENUITEMS = menuitems) {
    const theme = getState();
    let element = event.target;
    if ((theme.dataNavStyle != "icon-hover" && theme.dataNavStyle != "menu-hover") || (window.innerWidth < 992) || (theme.dataNavLayout != "horizontal") && (theme.toggled != "icon-hover-closed" && theme.toggled != "menu-hover-closed")) {
      for (const item of MENUITEMS) {
        if (item === targetObject) {
          if (theme.dataVerticalStyle == "doublemenu" && item.active) { return; }
          item.active = !item.active;

          if (item.active) {
            closeOtherMenus(MENUITEMS, item);
          } else {
            if (theme.dataVerticalStyle == "doublemenu") {
              const newState = {
                toggled: "double-menu-close"
              }
              setState(newState)

            }
          }
          setAncestorsActive(MENUITEMS, item);

        }
        else if (!item.active) {
          if (theme.dataVerticalStyle != "doublemenu") {
            item.active = false; // Set active to false for items not matching the target
          }
        }
        if (item.children && item.children.length > 0) {
          toggleSidemenu(event, targetObject, item.children);
        }
      }
      if (targetObject?.children && targetObject.active) {
        if (theme.dataVerticalStyle == "doublemenu" && theme.toggled != "double-menu-open") {
          const newState = {
            toggled: "double-menu-open"
          }
          setState(newState)

        }
      }
      if (element && theme.dataNavLayout == "horizontal" && (theme.dataNavStyle == "menu-click" || theme.dataNavStyle == "icon-click")) {
        const listItem = element.closest("li");
        if (listItem) {
          // Find the first sibling <ul> element
          const siblingUL = listItem.querySelector("ul");
          let outterUlWidth = 0;
          let listItemUL = listItem.closest("ul:not(.main-menu)");
          while (listItemUL) {
            listItemUL = listItemUL.parentElement.closest("ul:not(.main-menu)");
            if (listItemUL) {
              outterUlWidth += listItemUL.clientWidth;
            }
          }
          if (siblingUL) {
            // You've found the sibling <ul> element
            let siblingULRect = listItem.getBoundingClientRect();
            if (theme.dir == "rtl") {
              if ((siblingULRect.left - siblingULRect.width - outterUlWidth + 150 < 0 && outterUlWidth < window.innerWidth) && (outterUlWidth + siblingULRect.width + siblingULRect.width < window.innerWidth)) {
                targetObject.dirchange = true;
              } else {
                targetObject.dirchange = false;
              }
            } else {
              if ((outterUlWidth + siblingULRect.right + siblingULRect.width + 50 > window.innerWidth && siblingULRect.right >= 0) && (outterUlWidth + siblingULRect.width + siblingULRect.width < window.innerWidth)) {
                targetObject.dirchange = true;
              } else {
                targetObject.dirchange = false;
              }
            }
          }

        }
      }
      setMenuitems((arr) => [...arr]);
    }
  }

  function setAncestorsActive(MENUITEMS: Menuitemtype, targetObject: Menuitemtype) {
    const theme = getState();
    const parent = findParent(MENUITEMS, targetObject);
    if (parent) {
      parent.active = true;
      if (parent.active) {
        const newState = {
          toggled: "double-menu-open"
        }
        setState(newState)

      }

      setAncestorsActive(MENUITEMS, parent);
    } else {
      if (theme.dataVerticalStyle == "doublemenu") {
        const newState = {
          toggled: "double-menu-close"
        }
        setState(newState)

      }

    }
  }

  function closeOtherMenus(MENUITEMS: Menuitemtype, targetObject: Menuitemtype) {
    for (const item of MENUITEMS) {
      if (item !== targetObject) {
        item.active = false;
        if (item.children && item.children.length > 0) {
          closeOtherMenus(item.children, targetObject);
        }
      }
    }
  }

  function findParent(MenuItems: Menuitemtype[], targetObject: Menuitemtype): Menuitemtype | null {
    for (const item of MenuItems) {
      if (item.children && item.children.includes(targetObject)) {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const parent: Menuitemtype | null = findParent(MenuItems = item.children, targetObject);
        if (parent) {
          return parent;
        }
      }
    }
    return null;
  }
  //
  function HoverToggleInnerMenuFn(event: MouseEvent, item: Menuitemtype) {
    const theme = getState();;
    let element = event.target;
    if (element && theme.dataNavLayout == "horizontal" && (theme.dataNavStyle == "menu-hover" || theme.dataNavStyle == "icon-hover")) {
      const listItem = element.closest("li");
      if (listItem) {
        // Find the first sibling <ul> element
        const siblingUL = listItem.querySelector("ul");
        let outterUlWidth = 0;
        let listItemUL = listItem.closest("ul:not(.main-menu)");
        while (listItemUL) {
          listItemUL = listItemUL.parentElement.closest("ul:not(.main-menu)");
          if (listItemUL) {
            outterUlWidth += listItemUL.clientWidth;
          }
        }
        if (siblingUL) {
          // You've found the sibling <ul> element
          let siblingULRect = listItem.getBoundingClientRect();
          if (theme.dir == "rtl") {
            if ((siblingULRect.left - siblingULRect.width - outterUlWidth + 150 < 0 && outterUlWidth < window.innerWidth) && (outterUlWidth + siblingULRect.width + siblingULRect.width < window.innerWidth)) {
              item.dirchange = true;
            } else {
              item.dirchange = false;
            }
          } else {
            if ((outterUlWidth + siblingULRect.right + siblingULRect.width + 50 > window.innerWidth && siblingULRect.right >= 0) && (outterUlWidth + siblingULRect.width + siblingULRect.width < window.innerWidth)) {
              item.dirchange = true;
            } else {
              item.dirchange = false;
            }
          }
        }
      }
    }
  }

  const handleClick = (event: MouseEvent) => {
    // Your logic here
    event.preventDefault(); // Prevents the default anchor behavior (navigation)
    // ... other logic you want to perform on click
  };
  const toggleTheme = () => {
    const currentTheme = getState();
    const newState = {
      dataThemeMode: currentTheme.dataThemeMode === 'dark' ? 'light' : 'dark',
      dataHeaderStyles: currentTheme.dataThemeMode === 'transparent' ? 'light' : 'transparent',
      dataMenuStyles: currentTheme.dataThemeMode === 'transparent' ? 'light' : 'transparent',
    }
    setState(newState)
    if (newState.dataThemeMode != 'dark') {
      const newState = {
        bodyBg: '',
        lightRgb: '',
        bodyBg2: '',
        inputBorder: '',
        formControlBg: '',
        gray: '',
      }
      setState(newState)
      localStorage.setItem("udonlightTheme", "light");
      localStorage.removeItem("udondarkTheme");
      localStorage.removeItem("udonmenu");
      localStorage.removeItem("udonheader");
      localStorage.removeItem("bodyBg");
      localStorage.removeItem("bodyBg2");
      localStorage.removeItem("bgImg");
    }
    else {
      localStorage.setItem("udondarkTheme", "dark");
      localStorage.removeItem("udonlightTheme");
      localStorage.removeItem("udonmenu");
      localStorage.removeItem("udonheader");
      localStorage.removeItem("bodyBg");
      localStorage.removeItem("bodyBg2");
      localStorage.removeItem("inputBorder");
      localStorage.removeItem("lightRgb");
      localStorage.removeItem("formControlBg");
      localStorage.removeItem("gray");
    }
  }
  return (
    <Fragment>
      <div id="responsive-overlay" ref={overlayRef} onClick={() => { menuClose(); }}></div>
      {/* <!-- Start::app-sidebar --> */}

      <aside className="app-sidebar sticky" id="sidebar" onMouseOver={Onhover} onMouseLeave={Outhover} >

        {/* <!-- Start::main-sidebar-header --> */}

        <div className="main-sidebar-header">
          <Link to={`/my-schedule`} className="header-logo">
            <img src={branding.desktopLogo} alt={branding.alt} className="desktop-logo" />
            <img src={branding.toggleLogo} alt={branding.alt} className="toggle-logo" />
            <img src={branding.desktopDark} alt={branding.alt} className="desktop-dark" />
            <img src={branding.toggleDark} alt={branding.alt} className="toggle-dark" />
          </Link>
        </div>
        {/* <!-- End::main-sidebar-header --> */}

        {/* <!-- Start::main-sidebar --> */}

        <SimpleBar className="main-sidebar" id="sidebar-scroll">

          <div className="mobile-sidebar-pin-bar d-lg-none">
            <span className="mobile-sidebar-pin-label">Navigation</span>
            <button
              type="button"
              className={`btn btn-sm mobile-sidebar-pin-button ${mobileSidebarPinned ? "active" : ""}`}
              aria-pressed={mobileSidebarPinned}
              aria-label={mobileSidebarPinned ? "Unpin navigation menu" : "Pin navigation menu open"}
              onClick={toggleMobileSidebarPin}
            >
              <i
                className={mobileSidebarPinned ? "ri-pushpin-fill" : "ri-pushpin-line"}
                aria-hidden="true"
              ></i>
              <span>{mobileSidebarPinned ? "Pinned" : "Pin menu"}</span>
            </button>
          </div>

          {/* <!-- Start::nav --> */}
          <nav className="main-menu-container nav nav-pills flex-column sub-open">
            <div className="slide-left" id="slide-left" onClick={slideLeft} >
              <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path> </svg>
            </div>
            <ul className="main-menu">

              {/* <!-- Start::slide --> */}

              {MENUITEMS.map((list: Menuitemtype, index: number) => (
                <Fragment key={index}>
                  <li className={` ${list.menutitle ? "slide__category" : ""} ${list.type === 'link' ? 'slide' : ''} ${list.type === 'sub' ? 'slide has-sub' : ''} ${list.active ? 'open' : ''}  ${list?.selected ? 'active' : ''}  `}>
                    {list.menutitle ?
                      <span className='category-name'>{list.menutitle}</span>
                      :
                      ""}
                    {list.type === "link" ?
                      <Link to={list.path} className={`side-menu__item  ${list.selected ? 'active' : ''}`}>
                        <span className={`${local_varaiable?.dataVerticalStyle == 'doublemenu' ? '' : 'd-none'}`}>

                          <div>{list.icon}</div>

                        </span>
                        {local_varaiable.dataVerticalStyle != "doublemenu" ? list.icon : ""}
                        <span className="side-menu__label">{list.title} {list.badgetxt ? (<span className={list.class}>{list.badgetxt}</span>
                        ) : (
                          ""
                        )}
                        </span>
                      </Link>
                      : ""}
                    {list.type === "empty" ?
                      <Link to="#!" className='side-menu__item' onClick={handleClick} >{list.icon}<span className=""> {list.title} {list.badgetxt ? (
                        <span className={list.class}>{list.badgetxt} </span>
                      ) : (
                        ""
                      )}
                      </span>
                      </Link>
                      : ""}
                    {list.children && <Menuloop MenuItems={list} level={level + 1} handleToMenu={toggleSidemenu} HoverToggleInnerMenuFn={HoverToggleInnerMenuFn} />}
                  </li>


                </Fragment>
              ))}


              {/* <!-- End::slide --> */}

            </ul>

            <div className="slide-right" id="slide-right" onClick={slideRight} >
              <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
              </svg>
            </div>
          </nav>

          {/* <!-- End::nav --> */}

        </SimpleBar>

        {/* <!-- End::main-sidebar --> */}

      </aside>

      {/* <!-- End::app-sidebar --> */}

    </Fragment>
  )
}

export default Sidebar
